import { createAction, props } from '@ngrx/store';
import { ICurrentFasheet } from '../models/current-factsheet.model';

export const loadGetCurrentFactsheets = createAction('[GetCurrentFactsheet] Load GetCurrentFactsheets', props<{ request: string }>());

export const loadGetCurrentFactsheetsSuccess = createAction(
  '[GetCurrentFactsheet] Load GetCurrentFactsheets Success',
  props<{ response: ICurrentFasheet }>()
);

export const loadGetCurrentFactsheetsFailure = createAction(
  '[GetCurrentFactsheet] Load GetCurrentFactsheets Failure',
  props<{ error: Error | any }>()
);
